import { render, staticRenderFns } from "./LogListingItemClaim.vue?vue&type=template&id=c0faeb56&"
import script from "./LogListingItemClaim.vue?vue&type=script&lang=js&"
export * from "./LogListingItemClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports